import {Directive, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {BehaviorSubject, Observable, Subject, Subscription} from 'rxjs';
import {WithScrollContainer} from '../../_helpers/with-scroll-container';
import {SortingService} from '../../_services/sorting.service';
import {Utils} from '../../_helpers/Utils';
import {Stock} from '../stock';

@Directive()
export abstract class AbstractBaseCountComponent<TStock extends Stock = Stock>
  extends WithScrollContainer()
  implements OnDestroy {

  protected readonly onDestroy$ = new Subject<void>();
  subscriptions = new Subscription();

  @ViewChild('bedInput', {static: true}) bedInput: ElementRef;

  searchTerm: string;
  searchTermSubject = new BehaviorSubject<string>('');
  fetchingBedsSubject = new BehaviorSubject<boolean>(false);
  fetchingBeds$: Observable<boolean> = this.fetchingBedsSubject.asObservable();
  noBedsFoundMessage: string;

  useCustomSort = false;
  firstVisibleBedIndex = 0;
  protected readonly AMOUNT_BEDS_VISIBLE = 10;
  readonly Utils = Utils;

  protected previousDates: Map<number, Date> = new Map<number, Date>();

  constructor(protected sortingService?: SortingService) {
    super();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  resetSearchField() {
    this.searchTerm = '';
    this.searchTermSubject.next('');
  }

  /**
   * Toggles stock inspection timestamp between now and previous date.
   */
  protected applyInspectionToggle(stock: TStock): void {
    if (this.previousDates.has(stock.id) &&
      (new Date(this.previousDates.get(stock.id)) < new Date() || this.previousDates.get(stock.id) === undefined)) {
      stock.lastInspection = this.previousDates.get(stock.id);
      this.previousDates.delete(stock.id);
    } else {
      this.previousDates.set(stock.id, stock.lastInspection);
      stock.lastInspection = new Date();
    }
  }

  public async onAttach() {
    await super.onAttach();
    if (this.scrollPosition && this.scrollContainer) {
      this.scrollContainer.nativeElement.scrollTo(0, this.scrollPosition);
    } else if (!this.searchTerm && this.bedInput) {
      this.bedInput.nativeElement.focus();
    }
  }
}
